var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.9333 13.0667L41.3 14.7M7 28H9.33333H7ZM28 7V9.33333V7ZM46.6667 28H49H46.6667ZM13.0667 13.0667L14.7 14.7L13.0667 13.0667Z",
    stroke: "#D8D8EB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0007 37.3333C19.0417 35.8641 17.5948 33.8158 16.8647 31.4785C16.1346 29.1413 16.1584 26.6336 16.9327 24.3106C17.707 21.9876 19.1926 19.9672 21.179 18.5354C23.1655 17.1037 25.552 16.3333 28.0007 16.3333C30.4493 16.3333 32.8358 17.1037 34.8223 18.5354C36.8087 19.9672 38.2943 21.9876 39.0686 24.3106C39.8429 26.6336 39.8667 29.1413 39.1366 31.4785C38.4065 33.8158 36.9596 35.8641 35.0007 37.3333C34.0896 38.235 33.4037 39.3386 32.9984 40.5547C32.593 41.7708 32.4796 43.0652 32.6673 44.3333C32.6673 45.5709 32.1757 46.7579 31.3005 47.6331C30.4253 48.5083 29.2383 48.9999 28.0007 48.9999C26.763 48.9999 25.576 48.5083 24.7008 47.6331C23.8257 46.7579 23.334 45.5709 23.334 44.3333C23.5217 43.0652 23.4083 41.7708 23.003 40.5547C22.5976 39.3386 21.9117 38.235 21.0007 37.3333",
    stroke: "#D8D8EB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6309 39.6667H33.3642",
    stroke: "#D8D8EB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.10d27588fe212deb191a6e73d17651ba.svg";
export { ForwardRef as ReactComponent };